const apiUrl = process.env.VUE_APP_ROOT_API
const dealerPeakApiUrl = process.env.VUE_APP_ROOT_DP_API

export default {
  apiUrl,
  dealerPeakApiUrl
}
